<script lang="ts">
	import { ArtistDetailsPage } from '#lib/websites/artists/pages/ArtistDetailPage/index.js';
</script>

<ArtistDetailsPage />
